
export const solutions = {
  '1gb.solutions': 'Solutions 1Gb',
  '10gb.solutions': 'Solutions 10Gb',
  '1gb.vpx.accessories': 'Accessoires VPX 1Gb',
  'software': 'Logiciel',
  '1gb.description': 'Solutions AV sur IP 1Gb haute performance',
  '10gb.description': 'Solutions AV sur IP 10Gb ultra-haute performance',
  'vpx.accessories.description': 'Accessoires essentiels pour les solutions VPX 1Gb',
  'software.description': 'Le logiciel Aurora IPBaseT Manager est une application de contrôle tout-en-un pour les produits IPX, VPX et VLX de Aurora IPBaseT AV sur IP',
  'avoip.solutions': 'Solutions AVOIP',
  'choose.network.speed': 'Choisissez votre vitesse de réseau préférée',
  'touch.controllers': 'Contrôleurs tactiles',
  'touch.controllers.description': 'Interfaces de panneau tactile professionnelles pour un contrôle transparent',
  'control.processors': 'Processeurs de contrôle',
  'control.processors.description': 'Processeurs de contrôle avancés pour la gestion du système',
  'reax.software': 'Logiciel',
  'reax.software.description': 'Logiciel de développement de système de contrôle professionnel',
  'reax.accessories': 'Accessoires',
  'reax.accessories.description': 'Accessoires essentiels pour les systèmes ReAX',
  'reax.control.solutions': 'Solutions de contrôle ReAX',
  'choose.control.solution': 'Choisissez votre solution de contrôle préférée',
  'digital.signal.processors': 'Processeurs de signaux numériques',
  'dsps.description': 'Solutions professionnelles de traitement audio',
  'amplifiers': 'Amplificateurs',
  'amplifiers.description': 'Amplification audio haute performance',
  'speakers': 'Haut-parleurs',
  'speakers.description': 'Solutions de reproduction audio premium',
  'audio.solutions': 'Solutions audio',
  'choose.audio.solution': 'Choisissez votre solution audio préférée',
};
